import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import thunk from 'redux-thunk';
import createRootReducer from '../reducers/reducers';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from '../epics/rootEpic';

const epicMiddleware = createEpicMiddleware();

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
    const composeEnhancers =
        (typeof window !== 'undefined' &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
        compose;

    const store = createStore(
        createRootReducer(history), // root reducer with router state
        preloadedState,
        composeEnhancers(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                thunk,
                epicMiddleware
            )
        )
    );

    // Hot reloading
    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers/reducers', () => {
            store.replaceReducer(createRootReducer(history));
        });
    }

    epicMiddleware.run(rootEpic);

    return store;
}
